import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API_ENDPOINTS } from '../../../../utils/api';
import createAxiosInstance from "../../../../utils/axiosInstance";
import { formatDateShort, formatToUSD } from '../../../../utils/formatters';

type RecentDonationProps = {
  startIsOpenRequestsLoading: () => void;
  endIsOpenRequestsLoading: () => void;
  updateFeedOpenRequest: boolean;
};

const OpenRequest: React.FC<RecentDonationProps> = ({ startIsOpenRequestsLoading, endIsOpenRequestsLoading, updateFeedOpenRequest }) => {

  const axiosInstance = createAxiosInstance();
  const [recentNeedList, setRecentNeedList] = useState([]);

  useEffect(() => {
    getRecentNeed();
  }, []);

  useEffect(() => {
    if (updateFeedOpenRequest) {
      getRecentNeed();
    }
  }, [updateFeedOpenRequest]);

  const getRecentNeed = async () => {
    try {
      startIsOpenRequestsLoading();
      const response = await axiosInstance.get(`${API_ENDPOINTS.SAFENIIGHT.GETRECENTNEEDS}?expand=true&status=open&orderBy=sequenceId+desc&limit=5&skip=0`);

      const data = response.data?.map((element: any) => ({
        id: element.sequenceId,
        date: formatDateShort(element.createdAt),
        val: formatToUSD(element?.assessments[0].amount),
        reason:
          "needReason" in element.assessments[0]
            ? element.assessments[0].needReason
            : "",
        referenceUrl: `/safenight/needs/need-details/${element.needId}`,
      }));

      setRecentNeedList(data);
      endIsOpenRequestsLoading();
    } catch (error) {
      endIsOpenRequestsLoading();
      console.log(error);
    }
  };
  return (
    <div>
      <div className="relative md:overflow-hidden md:border md:border-borderGray rounded-xl">
        <table className="table_responsive_block w-full text-xs 2xl:text-sm text-left rtl:text-right">
          <thead className="text-xs 2xl:text-sm text-gray-600 bg-gray-100 border-b">
            <tr>
              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Alert #</th>
              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Data Requested</th>
              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Amount</th>
              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Reason</th>
            </tr>
          </thead>
          <tbody>
            {recentNeedList.map((item: any) => (
              <tr className={` border-b  bg-white `} key={item.id}>
                <td data-title='Alert #' scope="row" className="px-4 2xl:px-6 py-3 font-medium text-primary cursor-pointer whitespace-nowrap">
                  <Link to={item.referenceUrl}>{item.id}</Link>
                </td>
                <td data-title='Data Requested' className="px-4 2xl:px-6 py-3">{item.date}</td>
                <td data-title='Amount' className="px-4 2xl:px-6 py-3">{item.val}</td>
                <td data-title='Reason' className="px-4 2xl:px-6 py-3">{item.reason}</td>
              </tr>
            ))}
            {recentNeedList.length === 0 && (
              <tr>
                <td colSpan={4} className="text-center py-4 text-gray-500">There are no needs.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="mt-5 flex justify-end items-center">
        <Link to={'/safenight/needs'} className='text-secondary underline underline-offset-2 font-semibold'>View all Alerts</Link>
      </div>
    </div>
  );
};

export default OpenRequest;
